import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { BudgetConsolidationCards } from './budgetconsolidation.models';

const money = (value: any) => Number(value || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });

type Props = { cards: BudgetConsolidationCards | null };

export default class BudgetConsolidationCardsPanel extends React.PureComponent<Props> {
  render() {
    const c = this.props.cards;
    if (!c) return null;

    const items = [
      ['Approved Capacity', money(c.approvedcapacity)],
      ['Consolidated Budget', money(c.totalbudget)],
      ['Available Capacity', money(c.availablecapacity)],
      ['Capacity Variance', money(c.variance)],
      ['Activity Budget', money(c.activitybudget)],
      ['Direct Budget', money(c.directbudget)],
      ['Investment Budget', money(c.investmentbudget)],
      ['Pending Arbitrations', c.pendingarbitrations || 0],
    ];

    return (
      <Grid container spacing={2}>
        {items.map(([label, value]) => (
          <Grid key={String(label)} size={{ xs: 12, sm: 6, md: 3 }}>
            <Card elevation={1}>
              <CardContent>
                <Typography variant="caption" color="text.secondary">{label}</Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{value}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}
